/** Parse API due_date format d/m/Y (ServicesFeesResource). */
export function parseDMY(str: string): Date | null {
  if (!str || typeof str !== 'string') {
    return null
  }
  const parts = str.split('/')
  if (parts.length !== 3) {
    return null
  }
  const [d, m, y] = parts
  const date = new Date(+y, +m - 1, +d)
  return Number.isNaN(date.getTime()) ? null : date
}
